import { render, staticRenderFns } from "./TopUpBlock.vue?vue&type=template&id=5d2f041c&scoped=true"
import script from "./TopUpBlock.vue?vue&type=script&lang=js"
export * from "./TopUpBlock.vue?vue&type=script&lang=js"
import style0 from "./TopUpBlock.vue?vue&type=style&index=0&id=5d2f041c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2f041c",
  null
  
)

export default component.exports